import styled from '@emotion/styled'
import { colors } from '../../../../../component-library/src/Theme/Common'

export const SignUpPageHeaderStyled = styled.header({
  backgroundColor: colors.studio[700],
  color: colors.white,
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: '1.2rem 1.6rem',
})
